import React, { useRef } from 'react'
import { HeaderWrapper, Heading, P, SectionHeading, SectionSmallHeading, SectionWrapper } from '../../../Styles/style'
import styled from '@emotion/styled'
import { Grid, keyframes } from '@mui/material'
import king from "../../../../assets/images/king.png"
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const KingImg = styled.img`
  width: 100%;
  height:auto;
  max-width: 550px;
  @media screen and (max-height:670px){
    max-width: 449px;
  }
  @media screen and (max-width:899px){
    display:none;
  }
`
const pressAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
`;
const ReadMore = styled.button`
 color: #000;
  font-family: "P-SM";
  background: ${(props) => (props.bgcolor ? props.bgcolor : "#6FAE5F")};
  padding: 10px 45px;
  border: 2px solid #000;
  text-decoration: none;
  z-index: 1;
  margin: 0 20px 50px 0;
  font-size: 18px;
  box-shadow: inset 0px 1px 8px #ffffff91,-6px 5px 1px 1px #000;
  &:active {
    box-shadow: none;
    transform: scale(0.9);
    box-shadow: inset 0px 1px 8px #ffffff91;
  }
  @media screen and (max-width:499px){
    font-size: 13px;
    padding: 8px 25px;
  }
  animation: ${props => props.pressed ? pressAnimation : null} 0.3s ease-in-out;
`
const Contractdiv = styled.div`
color: #fff;
background: linear-gradient(270deg, rgba(230,189,35,1) 0%,rgba(230,189,35,1) 50%,rgba(230,189,35,1) 100%);
border:2px solid #000;
padding: 4px 25px;
box-shadow:inset 0px 1px 12px #ffffff91,-6px 5px 1px 1px #000;
text-decoration: none;
width:100%;
max-width:87%;
margin:0 0 50px 0;
display: flex;
align-items: center;
cursor: pointer;
@media screen and (max-width:899px){
  max-width:100%;
}
cursor: pointer;
box-shadow: inset 0px 1px 8px #ffffff91,-6px 5px 1px 1px #000;
  &:active {
    box-shadow: none;
    transform: scale(0.9);
    box-shadow: inset 0px 1px 8px #ffffff91;
  }
  animation: ${props => props.pressed ? pressAnimation : null} 0.3s ease-in-out;
`
const GridWrapper = styled(Grid)`
display: flex;
align-self: flex-end;
@media screen and (max-width:899px){
  
  padding:100px 20px 0;
}
`
const GridS = styled(Grid)`
@media screen and (max-width:899px){
}
`

const Textarea = styled.textarea`
font-size: 16px;
resize: none;
font-family: "P-SM";
cursor: pointer;
overflow: hidden;
color:#000;
border: none;
/* width:640px; */
width:100%;
height: 50px;
padding:8px 0 0;
/* padding:11px; */
background: transparent;
text-align: -webkit-center;
text-align: -moz-center;
outline: none;
@media screen and (max-width: 1500px) {
  /* width:340px; */
  
}
@media screen and (max-width: 1150px) {
  /* width:240px; */
  
}
@media screen and (max-width: 899px) {
  
  /* width:540px; */
  
}
@media screen and (max-width: 750px) {
  /* height: UNSET; */
    /* width:UNSET; */
}
`;
const ContractAdd = styled.span`
word-break: keep-all;
/* padding:30px 0 0; */
display: flex;
align-items: center;

`;
const Index = () => {

  const textAreaRef = useRef(null);
  const handleClick = () => {
    const textToCopy = '0x06Acd2fbBDF6E6a95415f0199b265caF3dA9E3DD';
    navigator.clipboard.writeText(textToCopy);
    toast.success('0x06Acd2fbBDF6E6a95415f0199b265caF3dA9E3DD');
  };
  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand("copy");
    // This is just personal preference.
    // I prefer to not show the whole text area selected.
    e.target.focus();
  }
  return (
    <div>
      
      <ToastContainer />
      <HeaderWrapper id="home">
        {/* <Container maxWidth="xl"> */}
        <GridWrapper container>
          <Grid xs={12} md={5} data-aos="fade-zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="700"
            data-aos-offset="0"
            data-aos-duration="500"><KingImg src={king} /></Grid>
          <GridS xs={12} md={6}>
            <SectionHeading fs599="60px" data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="600"
              data-aos-offset="0"
              data-aos-duration="500">PehPeh ペペ</SectionHeading>
            <Heading maxWidth="80%" p="20px 0" data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="700"
              data-aos-offset="0"
              data-aos-duration="500">Konnichiwa, I’m PehPeh ペペ, the heroic twin Japanese brother of PEPE with killer samurai skills! I’m here to aid PEPE against rival meme tokens.</Heading>
            <Contractdiv data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="700"
              data-aos-offset="0"
              data-aos-duration="500"  onClick={handleClick}>
              <Heading fs1100="16px" p="0" m="0" fs599="16PX" style={{fontSize:'16px'}}>Contract:</Heading>  
                <Textarea onClick={copyToClipboard} ref={textAreaRef} value="0x06Acd2fbBDF6E6a95415f0199b265caF3dA9E3DD" />
            </Contractdiv>
            <ReadMore data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="800"
              data-aos-offset="0"
              data-aos-duration="500">< a href="https://app.uniswap.org/#/swap?chainId=1&outputCurrency=0x06Acd2fbBDF6E6a95415f0199b265caF3dA9E3DD">Buy Now</a></ReadMore>
              {/* https://app.uniswap.org/#/swap?chainId=1&outputCurrency=0x06Acd2fbBDF6E6a95415f0199b265caF3dA9E3DD */}
            <ReadMore bgcolor="#CF2829" data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="800"
              data-aos-offset="0"
              data-aos-duration="500" ><a href="https://dexscreener.com/ethereum/0x8e97e6cb13da296fe950edb40988296a7b862d7d">View Chart</a></ReadMore>
          </GridS></GridWrapper>
        {/* </Container> */}
      </HeaderWrapper>

    </div>
  )
}

export default Index